export { default } from './CompletionOfClinicalActivityForm';
